import { render, staticRenderFns } from "./ModalInner.vue?vue&type=template&id=5845ada6"
import script from "./ModalInner.vue?vue&type=script&lang=js"
export * from "./ModalInner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports